const deviceCapacity = {
    AQ290: 500,
    AQ380: 500,
    AQ580: 500,
    AQ880w1250: 1250,
    AQ880w2500: 2500,
    AQ1280: 1250,
    AQ2500: 2500,
}

export default function(fragrances, systemConfiguration, onTime, fragrance) {
    
    const fragData = fragrances.find(f => f.fragrance === fragrance)
    const capacity = deviceCapacity[systemConfiguration]

    const onTimeHours = onTime / 3600

    if (!fragData) {
        console.log('no fragrance data to perform calculation', capacity, onTimeHours, fragData)
        return null
    }

    let output = 0
    switch (systemConfiguration) {
        case 'AQ290':
            output = fragData.aQ290 ?? -1
            break

        case 'AQ380':
            output = fragData.aQ380 ?? -1
            break

        case 'AQ580':
            output = fragData.aQ580 ?? -1
            break

        case 'AQ880w1250':
            output = fragData.aQ880w1250 ?? -1
            break

        case 'AQ880w2500':
            output = fragData.aQ880w2500 ?? -1
            break
    
        case 'AQ1280':
            output = fragData.aQ1280w1250 ?? -1
            break

        case 'AQ2500':
              output = fragData.aQ1280w2500 ?? -1
              break

      default:
            return null
    }

    if (output <= 0) return null

    const density = fragData.density
    const usedPerHour = output / density
    const used = onTimeHours * usedPerHour
    const remaining = Math.max(0, capacity - used)

    return remaining / capacity
}
